<template>
  <table
    id="table"
    :class="$style.table"
  >
    <thead>
      <tr>
        <th
          v-for="column in columns"
          :key="column.field"
          :style="{
            width: `${column.width}%`,
          }"
          @click="onColumnClick(column.field)"
        >
          {{ column.title }}
          <span
            v-if="sortedColumn === column.field"
            :class="[$style.sort, { [$style.desc]: !isSortAscending }]"
          >
            ▾
          </span>
        </th>
      </tr>
    </thead>

    <template v-if="tableData.length">
      <template v-for="[key, { title, data }] in tableData">
        <tr :key="`tr-${key}`">
          <td
            :colspan="columns.length"
            :class="$style.tdCollapse"
          >
            <button
              :class="$style.btnAccordion"
              @click="toggleAccordion(key)"
            >
              <span :class="{ [$style.caretClosed]: !isOpenMap[key] }">
                <img
                  src="@/assets/images/icons/computer/screenshots/additional-angle.svg"
                  :class="$style.addAngel"
                >
              </span>
              <div :class="$style.header">
                <span :class="$style.headerText">{{ title }}</span>
              </div>
            </button>
          </td>
        </tr>
        <template v-if="data && isOpenMap[key]">
          <tbody
            :key="`tbody-${key}`"
            :class="{ [$style.clickable]: clickable }"
          >
            <tr
              v-for="(row, idx) in data"
              :key="`${row.id}-${idx}`"
              @click="onRowClick(row.id)"
              @focus="onRowClick(row.id)"
              @contextmenu.prevent="$emit('showMenu', $event, row.msgLogin, row.values)"
            >
              <td
                v-for="column in columns"
                :key="column.field"
                :class="{
                  [$style.textCentr]: column.center,
                }"
              >
                {{ row[column.field] }}
              </td>
            </tr>
          </tbody>
        </template>
      </template>
    </template>
    <tbody v-if="!tableData.length">
      <tr>
        <td :colspan="columns.length">
          {{ $t('table.noData') }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
  import { isEmpty } from 'lodash';
  import { CATEGORIES } from './const/const';

  export default {
    model: {
      prop: 'rowActiveId',
      event: 'row-click',
    },
    props: {
      columns: {
        type: Array,
        required: true,
      },
      data: {
        type: Object,
        required: true,
      },
      clickable: {
        type: Boolean,
        default: false,
      },
      rowActiveId: {
        type: [Number, String],
        default: null,
      },
    },
    data: () => ({
      sortedColumn: null,
      isSortAscending: true,
      isOpenMap: {
        [CATEGORIES.ESTABLISHED.key]: true,
        [CATEGORIES.OTHER.key]: true,
      },
    }),
    computed: {
      tableData() {
        if (isEmpty(this.data)) return [];
        return Object.entries(this.data).map(([key, value]) => [
          key,
          {
            ...value,
            data: [...value.data]?.sort(this.compare) || [],
          },
        ]);
      },
    },
    created() {
      const currentSorted = this.columns.find((item) => item?.sorted);
      if (currentSorted) this.sortedColumn = currentSorted.field;
    },
    methods: {
      toggleAccordion(key) {
        this.$set(this.isOpenMap, key, !this.isOpenMap[key]);
      },
      compare(a, b) {
        a = a[this.sortedColumn];
        b = b[this.sortedColumn];

        if (typeof a === 'string' && typeof b === 'string') {
          a = a.toLowerCase();
          b = b.toLowerCase();
        }

        if (this.isSortAscending) {
          if (a > b) {
            return -1;
          }

          if (a < b) {
            return 1;
          }
          return 0;
        }

        if (a < b) {
          return -1;
        }

        if (a > b) {
          return 1;
        }

        return 0;
      },
      isSortedColumn(column) {
        return this.sortedColumn === column;
      },
      onColumnClick(column) {
        if (column === this.sortedColumn) {
          this.isSortAscending = !this.isSortAscending;
        } else {
          this.sortedColumn = column;
          this.isSortAscending = true;
        }
      },
      onRowClick(id) {
        if (this.clickable && this.rowActiveId !== id) {
          // Второе условие - костыль
          this.$emit('row-click', id);
        }
      },
      focusRow(idx) {
        const elems = document.getElementsByTagName('tr');

        for (let i = elems.length; i--; ) {
          const tidx = parseInt(elems[i].getAttribute('tabindex'), 10);
          if (tidx === idx + 1) {
            elems[i].focus();
          }
        }
      },
    },
  };
</script>

<style lang="scss" module>
  .table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;

    td,
    th {
      border: 1px solid $borderColor;
      padding: 6px;
      word-break: break-all;
    }

    th {
      user-select: none;
      background: $light-gray;
      font: 400 13px/18px Inter, sans-serif;
      cursor: pointer;
      background: #dbf1ff;
    }

    td {
      font-size: 12px;
    }

    tbody.clickable tr {
      cursor: pointer;

      &:hover {
        background: $light-gray;
      }

      &.active {
        background: $light-gray;
      }
    }
  }

  .sort {
    display: inline-block;
    margin-left: 6px;
    color: $dark-gray;
  }

  .desc {
    transform: rotate(180deg);
  }

  .textCentr {
    text-align: center;
  }

  .btnAccordion {
    cursor: pointer;
    font-size: 13px;
    user-select: none;
    border: none;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0 5px;
    background-color: $white;
    gap: 10px;
  }

  .header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .headerText {
    color: #7e7e7e;
    font-weight: 300;
    font-size: 12px;
    line-height: 27px;
  }
  .addAngel {
    height: 6px;
  }
  .caretClosed {
    transform: rotate(270deg);
  }
  .tdCollapse {
    padding: 0 !important;
  }
</style>
